import React, { FC } from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { BigHeaderProps } from './BigHeader.types';

export const BigHeader: FC<BigHeaderProps> = ({ title, className }) => (
    <h1 className={cx(styles.header, className)}>{title}</h1>
);
